import { mapGetters } from 'vuex';

export default {
    name: 'marketSchool',
    computed: {
        ...mapGetters('glb', ['glb']),
        ...mapGetters('msp', ['msp', 'getMarketInfo', 'getGeoPath', 'getGeoDisplayText']),
        getSchoolsLink() {
            return this.glb.geo.geoType === 'STATE' ? `${this.glb.appUrl}${this.getGeoPath || ''}schools/` : `${this.glb.appUrl}schools/${this.getGeoPath || ''}`;
        },
        getSchoolImagePath() {
            return this.glb.cdnUrl + 'images/desktop/s-img/greatschool-inline.png';
        },
    },
};
